<div *ngIf="entidade.proponentes?.length > 0" [class]="'row ' + (edicao ? 'mt-3 mb-3' : '')">
  <div class="col-12">
    <button data-toggle="modal" data-target="#dialogPropostaCad" class="btn btn-sm btn-primary" *ngIf="edicao">
      <i class="fa fa-refresh"></i> Atualizar propostas
    </button>
    <button *ngIf="entidade.modalidade?.codigo !== 7 && edicao" (click)="julgarPropostas()"
      class="btn btn-sm btn-success ml-2">
      <i class="fa fa-legal"></i> Julgar propostas
    </button>
    <button (click)="visualizarProponentes = !visualizarProponentes"
      class="btn btn-sm btn-link text-secondary float-right" title="Visualização por Item/Proponente">
      <i class="fa fa-object-group"></i>
    </button>
  </div>
</div>
<div class="row">
  <div class="col-md-12" *ngIf="!visualizarProponentes">
    <p-fieldset
      [legend]="memorial.ordem + ' - ' + funcaoService.abreviarStr(memorial?.descricao, 100, true) + ' (' + memorial.unidade + ')'"
      [toggleable]="memorial.propostas?.length > 0" [collapsed]="0 >= memorial.propostas?.length"
      *ngFor="let memorial of entidade?.itens">

      <table class="table table-sm table-eddy mb-0">
        <thead>
          <tr>
            <th scope="col" style="width: 55%">Favorecido</th>
            <th scope="col">Qtd.</th>
            <th scope="col" style="width: 170px">Marca</th>
            <th scope="col" style="width: 90px">Valor Unit.</th>
            <th scope="col" style="width: 100px">Total</th>
            <th scope="col" class="text-center" style="width: 100px">Situação</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let proposta of memorial.propostas">
            <td>{{proposta.proponente?.favorecido?.nome}}</td>
            <td class="text-right">{{+memorial.quantidade | number:'1.0-0'}}</td>
            <td>{{proposta.marca}}</td>

            <!-- valor -->
            <td class="text-right"
              *ngIf="entidade.modalidade?.codigo !== 7 || (entidade.modalidade?.codigo === 7 && proposta.situacao !== 'VENCEDOR')">
              {{+proposta.valor_unitario | number:'1.4-4'}}
            </td>
            <td class="text-right" *ngIf="entidade.modalidade?.codigo === 7 && proposta.situacao === 'VENCEDOR'">
              <span class="text-muted text-decoration-line-through d-block">
                {{+proposta.valor_unitario | number:'1.4-4'}}
              </span>
              <span class="font-weight-bold">{{+proposta.valor_final | number:'1.4-4'}}</span>
            </td>

            <!-- total -->
            <td class="text-right"
              *ngIf="entidade.modalidade?.codigo !== 7 || (entidade.modalidade?.codigo === 7 && proposta.situacao !== 'VENCEDOR')">
              {{+memorial.quantidade * +proposta.valor_unitario | number:'1.4-4'}}
            </td>
            <td class="text-right" *ngIf="entidade.modalidade?.codigo === 7 && proposta.situacao === 'VENCEDOR'">
              {{+proposta.quantidade_final * +proposta.valor_final | number:'1.4-4'}}
            </td>

            <td class="text-center">
              <span [class]="'badge badge-' + (obterEstiloProposta(proposta))">{{obterNomeProposta(proposta)}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </p-fieldset>
  </div>
  <div class="col-md-12" *ngIf="visualizarProponentes">
    <p-fieldset [legend]="proponente.favorecido.nome" [toggleable]="proponente.propostas?.length > 0"
      [collapsed]="0 >= proponente.propostas?.length" *ngFor="let proponente of entidade?.proponentes">
      <table class="table table-sm table-eddy mb-0">
        <thead>
          <tr>
            <th scope="col" style="width: 55%">Item</th>
            <th scope="col">Qtd.</th>
            <th scope="col" style="width: 170px">Marca</th>
            <th scope="col" style="width: 90px">Valor Unit.</th>
            <th scope="col">Total</th>
            <th scope="col" class="text-center" style="width: 100px">Situação</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let proposta of proponente.propostas">
            <td>{{proposta.memorial?.ordem}} - {{funcaoService.abreviarStr(proposta.memorial?.descricao, 80, true)}}
            </td>
            <td class="text-right">{{+proposta.memorial.quantidade | number:'1.0-0'}}</td>
            <td>{{proposta.marca}}</td>

            <!-- valor -->
            <td class="text-right"
              *ngIf="entidade.modalidade?.codigo !== 7 || (entidade.modalidade?.codigo === 7 && proposta.situacao !== 'VENCEDOR')">
              {{+proposta.valor_unitario | number:'1.4-4'}}
            </td>
            <td class="text-right" *ngIf="entidade.modalidade?.codigo === 7 && proposta.situacao === 'VENCEDOR'">
              <span class="text-muted text-decoration-line-through d-block">
                {{+proposta.valor_unitario | number:'1.4-4'}}
              </span>
              <span class="font-weight-bold">{{+proposta.valor_final | number:'1.4-4'}}</span>
            </td>

            <!-- total -->
            <td class="text-right"
              *ngIf="entidade.modalidade?.codigo !== 7 || (entidade.modalidade?.codigo === 7 && proposta.situacao !== 'VENCEDOR')">
              {{+proposta.memorial.quantidade * +proposta.valor_unitario | number:'1.4-4'}}
            </td>
            <td class="text-right" *ngIf="entidade.modalidade?.codigo === 7 && proposta.situacao === 'VENCEDOR'">
              {{+proposta.quantidade_final * +proposta.valor_final | number:'1.4-4'}}
            </td>

            <td class="text-center">
              <span [class]="'badge badge-' + (obterEstiloProposta(proposta))">{{obterNomeProposta(proposta)}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </p-fieldset>
  </div>
</div>

<div class="modal fade" id="dialogPropostaCad" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">Inclusão de Propostas</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-2" style="overflow-x: hidden">
        <div class="row">
          <div class="form-group col-8">
            <label for="propostacad_proponente">Selecione o favorecido que deseja visualizar/adicionar propostas</label>
            <select [compareWith]="compareFn" [(ngModel)]="proponenteAtual" [ngModelOptions]="{standalone: true}"
              id="propostacad_proponente" class="form-control" (change)="carregarPropostas()">
              <option *ngFor="let item of entidade.proponentes" [ngValue]="item">{{item.favorecido.nome}}</option>
            </select>
          </div>
          <div class="form-group col-4">
            <div class="checkbox checbox-switch switch-primary mt-4 float-right">
              <label>
                <input type="checkbox" (change)="toggleApenasCotacoes()" [(ngModel)]="apenasCotacoes"
                  [ngModelOptions]="{standalone: true}" /><span></span>Visualizar apenas com cotações
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-eddy">
              <thead>
                <tr>
                  <th scope="col">Item</th>
                  <th scope="col" style="width: 60px">Qtd.</th>
                  <th scope="col" style="width: 170px">Marca</th>
                  <th scope="col" style="width: 90px">Valor Unit.</th>
                  <th scope="col" style="width: 100px">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of proponenteAtual?.propostas; let idx = index"
                  class="{{!item.valor_unitario ? 'linha-cancelada': ''}}">
                  <td>
                    <span>{{item.memorial?.ordem}}</span>
                    <span class="word-break-all d-sm-none d-md-none d-lg-block">
                      - {{funcaoService.abreviarStr(item.memorial?.descricao, 100, true)}}
                      ({{item.memorial?.unidade}})
                    </span>
                  </td>
                  <td class="text-right">{{+item.memorial?.quantidade | number:'1.0-0'}}</td>

                  <td>
                    <input list="datalistMarcas" [(ngModel)]="item.marca" [ngModelOptions]="{standalone: true}"
                      type="text" class="form-control form-control-sm" (blur)="atualizarMarcas()">
                    <datalist id="datalistMarcas">
                      <option [value]="m" *ngFor="let m of marcas">
                    </datalist>
                  </td>

                  <td class="text-right">
                    <input #valor_unitario_ [(ngModel)]="item.valor_unitario" [ngModelOptions]="{standalone: true}"
                      type="text" class="form-control form-control-sm" unmask="typed" [imask]="imaskConfig">
                  </td>

                  <td class="text-right">
                    {{+item.memorial?.quantidade * +item.valor_unitario | number:'1.4-4'}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row" style="width: 100%">
          <div class="col-12 p-0">
            <button *ngIf="proponenteAtual" data-toggle="modal" data-target="#dialogImportarMapaPreco"
              data-dismiss="modal" class="btn btn-sm text-success" title="Importar Mapa de preço">
              <i class="fa fa-reply"></i> Importar
            </button>

            <button type="button" class="btn btn-sm btn-link float-right ml-2" data-dismiss="modal">Fechar</button>
            <button (click)="confirmar()" type="button" class="btn btn-sm btn-primary float-right">
              <i class="fa fa-check"></i> Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="dialogImportarMapaPreco" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-success">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">Importar Mapa de preço</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-2">
        <div class="row">
          <div class="col-8">
            <span class="font-weight-bold">Fornecedor: </span>
            <span>{{proponenteAtual?.favorecido?.nome}}</span>
          </div>
          <div class="col-4">
            <span class="font-weight-bold">Documento: </span>
            <span>{{proponenteAtual?.favorecido?.cpf_cnpj | CPF}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p-fileUpload #fileUpload customUpload=true (uploadHandler)="onUpload($event, fileUpload)"
              chooseLabel="Selecione o mapa de preços do fornecedor para importá-lo" [auto]="true" accept=".xlsx">
            </p-fileUpload>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <ul class="list-group">
              <li class="list-group-item bg-danger text-white font-weight-bold" *ngFor="let erro of erros">{{erro}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="fecharImportar()" class="btn btn-sm btn-link text-muted">Fechar</button>
      </div>
    </div>
  </div>
</div>